<div class="min-h-screen flex flex-col font-sans bg-cloud-mist">

  <main class="tfr-page-shell flex-1 py-8 sm:py-12">

    <!-- Loading -->
    @if (loading()) {
      <div class="flex justify-center items-center py-24">
        <svg class="animate-spin h-8 w-8 text-action-blue" xmlns="http://www.w3.org/2000/svg"
             fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
        </svg>
      </div>
    }

    <!-- Not found -->
    @if (!loading() && notFound()) {
      <div class="flex flex-col items-center justify-center py-28 text-center">
        <div class="h-16 w-16 rounded-2xl bg-pale-gray flex items-center justify-center mb-5">
          <lucide-icon name="building-2" [size]="28" class="text-steel-gray" />
        </div>
        <h1 class="text-[20px] font-bold text-midnight-indigo mb-2">Propietario no encontrado</h1>
        <p class="text-[13px] text-slate-blue mb-6">Este propietario no tiene espacios publicados en TimeFlexRent.</p>
        <a routerLink="/explorar"
           class="inline-flex items-center gap-2 rounded-xl bg-action-blue px-5 py-2.5 text-[13px] font-semibold text-white hover:brightness-110 transition-all">
          <lucide-icon name="compass" [size]="15" />
          Explorar espacios
        </a>
      </div>
    }

    <!-- Owner profile + spaces -->
    @if (!loading() && !notFound()) {

      <!-- Owner hero card -->
      <div class="mb-8 rounded-2xl border border-pale-gray bg-white p-5 sm:p-7 shadow-tfr-sm flex flex-col sm:flex-row items-start gap-5">
        <!-- Avatar -->
        <div class="h-14 w-14 rounded-2xl flex items-center justify-center bg-action-blue/10 shrink-0">
          <span class="text-[22px] font-bold text-action-blue">{{ ownerInitials() }}</span>
        </div>

        <!-- Info -->
        <div class="flex-1 min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-widest text-steel-gray mb-0.5">
            Perfil de propietario · TimeFlexRent
          </p>
          <h1 class="text-[22px] sm:text-[26px] font-bold text-midnight-indigo leading-tight">
            {{ ownerName() }}
          </h1>
          <p class="text-[13px] text-slate-blue mt-1">
            {{ spaces().length }} espacio{{ spaces().length !== 1 ? 's' : '' }} disponible{{ spaces().length !== 1 ? 's' : '' }}
          </p>

          <!-- Category tags -->
          @if (categorySummary().length > 0) {
            <div class="flex flex-wrap gap-2 mt-3">
              @for (tag of categorySummary(); track tag.cat) {
                <span class="inline-flex items-center h-6 px-2.5 rounded-full bg-action-blue/8
                             text-action-blue text-[11px] font-semibold border border-action-blue/15">
                  {{ tag.label }}
                  @if (tag.count > 1) { <span class="ml-1 opacity-60">×{{ tag.count }}</span> }
                </span>
              }
            </div>
          }
        </div>

        <!-- Action -->
        <a routerLink="/explorar"
           class="hidden sm:inline-flex items-center gap-2 rounded-xl border border-pale-gray px-4 py-2
                  text-[12px] font-semibold text-slate-blue hover:text-action-blue hover:border-action-blue/30
                  transition-colors shrink-0">
          <lucide-icon name="compass" [size]="13" />
          Ver todos
        </a>
      </div>

      <!-- Spaces grid -->
      <div class="mb-4 flex items-center justify-between">
        <h2 class="text-[15px] font-bold text-midnight-indigo">
          Espacios publicados
        </h2>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        @for (space of spaces(); track space.id) {
          <app-space-card [space]="space" />
        }
      </div>

    }

  </main>

  <app-site-footer />

</div>
